import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import VideosIcon from "@material-ui/icons/VideoLibrary";
import { languages } from "../constants/languages";
import ListSubheader from "@material-ui/core/ListSubheader";
import PeopleIcon from "@material-ui/icons/People";
import DashboardIcon from "@material-ui/icons/Dashboard";
import TimerIcon from "@material-ui/icons/Timer";
import ViewListIcon from "@material-ui/icons/ViewList";
import AirplayIcon from "@material-ui/icons/Airplay";
import ChatIcon from "@material-ui/icons/Chat";
import HelpIcon from "@material-ui/icons/LiveHelp";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Button from "@material-ui/core/Button";
import InfoIcon from "@material-ui/icons/Info";
import SunnyIcon from "@material-ui/icons/WbSunny";

const drawerWidth = 310;

const styles = theme => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0
  },
  drawerPaper: {
    width: drawerWidth
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: "0 8px",
    ...theme.mixins.toolbar,
    justifyContent: "flex-start",
    fontWeight: 600,
    fontSize: 18
  },
  info: {
    backgroundColor: theme.palette.primary.main
  }
});

const supportTexts = {
  0: (
    <div>
      <Typography style={{ fontWeight: 500, fontSize: 17 }}>
        {languages.supportDrawer.addTeamsRefsAdmins}
      </Typography>
      <Typography>
        {languages.supportDrawer.teamsRefsAdminsDescription}
      </Typography>
      <br />
      <Typography style={{ fontWeight: 500 }}>
        {languages.supportDrawer.manageTeamsTitle}
      </Typography>
      <Typography>{languages.supportDrawer.manageTeamsDescription1}</Typography>
      <br />
      <Typography>{languages.supportDrawer.manageTeamsDescription2}</Typography>
      <br />
      <Typography
        style={{
          background: "rgb(236, 239, 241)",
          padding: 5,
          borderRadius: 5
        }}
      >
        <InfoIcon style={{ height: 15, width: 15 }} />
        {" " + languages.supportDrawer.manageTeamsInfo}
      </Typography>
      <br />

      <Typography style={{ fontWeight: 500 }}>
        {languages.supportDrawer.manageRefsTitle}
      </Typography>
      <Typography>{languages.supportDrawer.manageRefsDescription1}</Typography>
      <br />
      <Typography>{languages.supportDrawer.manageRefsDescription2}</Typography>
      <br />
      <Typography style={{ fontWeight: 500 }}>
        {languages.supportDrawer.manageAdminsTitle}
      </Typography>
      <Typography>{languages.supportDrawer.manageAdminsDescription}</Typography>
      <br />
      <Typography
        style={{
          background: "rgb(236, 239, 241)",
          padding: 5,
          borderRadius: 5
        }}
      >
        <InfoIcon style={{ height: 15, width: 15 }} />
        {" " + languages.supportDrawer.manageAdminsInfo}
      </Typography>
    </div>
  ),
  1: (
    <div>
      <Typography style={{ fontWeight: 500, fontSize: 17 }}>
        {languages.supportDrawer.createFormat}
      </Typography>
      <Typography>{languages.supportDrawer.createFormatDescription}</Typography>
      <br />
      <Typography>
        <span style={{ fontWeight: 500 }}>
          {languages.supportDrawer.createFormatPoule}
        </span>
        {languages.supportDrawer.createFormatPouleDescription}
      </Typography>
      <br />
      <Typography>
        <span style={{ fontWeight: 500 }}>
          {languages.supportDrawer.createFormatBracket}
        </span>
        {languages.supportDrawer.createFormatBracketDescription}
      </Typography>
      <br />
      <Typography>
        <span style={{ fontWeight: 500 }}>
          {languages.supportDrawer.createFormatSingleMatch}
        </span>
        {languages.supportDrawer.createFormatSingleMatchDescription}
      </Typography>
      <br />
      <Typography>
        {languages.supportDrawer.createFormatDescription2}
      </Typography>
      <br />
      <Typography
        style={{
          background: "rgb(236, 239, 241)",
          padding: 5,
          borderRadius: 5
        }}
      >
        <InfoIcon style={{ height: 15, width: 15 }} />
        {" " + languages.supportDrawer.createFormatInfo}
      </Typography>
      <br />
      <Typography>
        {languages.supportDrawer.createFormatDescription3}
      </Typography>
    </div>
  ),
  2: (
    <div>
      <Typography style={{ fontWeight: 500, fontSize: 17 }}>
        {languages.supportDrawer.createSchedule}
      </Typography>
      <Typography>
        {languages.supportDrawer.createScheduleDescription}
      </Typography>
      <br />
      <Typography>
        {languages.supportDrawer.createScheduleDescription2}
      </Typography>
      <br />
      <Typography
        style={{
          background: "rgb(236, 239, 241)",
          padding: 5,
          borderRadius: 5
        }}
      >
        <InfoIcon style={{ height: 15, width: 15 }} />
        {" " + languages.supportDrawer.createScheduleInfo}
      </Typography>
      <br />
      <Typography>
        {languages.supportDrawer.createScheduleDescription3}
      </Typography>
      <br />
      <Typography>
        {languages.supportDrawer.createScheduleDescription4}
      </Typography>
    </div>
  ),
  3: (
    <div>
      <Typography style={{ fontWeight: 500, fontSize: 17 }}>
        {languages.supportDrawer.present}
      </Typography>
      <Typography>{languages.supportDrawer.presentDescription}</Typography>
      <br />
      <Typography style={{ fontWeight: 500 }}>
        {languages.supportDrawer.publicWebsite}
      </Typography>
      <Typography>
        {languages.supportDrawer.publicWebsiteDescription}
      </Typography>
      <br />
      <Typography style={{ fontWeight: 500 }}>
        {languages.supportDrawer.slideshow}
      </Typography>
      <Typography>{languages.supportDrawer.slideshowDescription}</Typography>
      <br />
      <Typography style={{ fontWeight: 500 }}>
        {languages.supportDrawer.design}
      </Typography>
      <Typography>{languages.supportDrawer.designDescription}</Typography>
    </div>
  ),
  4: (
    <div>
      <Typography style={{ fontWeight: 500, fontSize: 17 }}>
        {languages.supportDrawer.processResults}
      </Typography>
      <Typography>
        {languages.supportDrawer.processResultsDescription}
      </Typography>
      <br />
      <Typography
        style={{
          background: "rgb(236, 239, 241)",
          padding: 5,
          borderRadius: 5
        }}
      >
        <InfoIcon style={{ height: 15, width: 15 }} />
        {" " + languages.supportDrawer.processResultsInfo}
      </Typography>
      <br />
      <Typography>
        {languages.supportDrawer.processResultsDescription2}
      </Typography>
      <br />
      <Typography>
        {languages.supportDrawer.processResultsDescription3}
      </Typography>
      <br />
      <Typography>
        {languages.supportDrawer.processResultsDescription4}
      </Typography>
    </div>
  )
};

class SupportDrawer extends React.Component {
  state = {
    supportText: undefined
  };

  handleClick = num => {
    this.setState({ supportText: num });
  };

  render() {
    const { classes, theme } = this.props;
    const { open } = this.props;

    return (
      <Drawer
        className={classes.drawer}
        variant="persistent"
        anchor="right"
        open={open}
        classes={{
          paper: classes.drawerPaper
        }}
      >
        <div className={classes.drawerHeader}>
          <IconButton onClick={this.props.handleClose}>
            {theme.direction === "rtl" ? (
              <ChevronLeftIcon />
            ) : (
              <ChevronRightIcon />
            )}
          </IconButton>
          {languages.header.support}
        </div>
        <Divider />
        {this.state.supportText === undefined ? (
          <div>
            <div>
              <List
                subheader={
                  <ListSubheader>
                    {languages.supportDrawer.videos}
                  </ListSubheader>
                }
              >
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={languages.header.supportVideosLink}
                  style={{ color: "#000", textDecoration: "none" }}
                >
                  <ListItem button>
                    <ListItemIcon>{<VideosIcon />}</ListItemIcon>
                    <ListItemText
                      primary={languages.supportDrawer.watchVideos}
                    />
                  </ListItem>
                </a>
              </List>
              <Divider />
              <List
                subheader={
                  <ListSubheader>
                    {languages.supportDrawer.createTournamentSchedule}
                  </ListSubheader>
                }
              >
                <ListItem
                  button
                  onClick={e => {
                    this.handleClick(0);
                  }}
                >
                  <ListItemIcon>{<PeopleIcon />}</ListItemIcon>
                  <ListItemText
                    primary={languages.supportDrawer.addTeamsRefsAdmins}
                  />
                </ListItem>
                <ListItem
                  button
                  onClick={e => {
                    this.handleClick(1);
                  }}
                >
                  <ListItemIcon>{<DashboardIcon />}</ListItemIcon>
                  <ListItemText
                    primary={languages.supportDrawer.createFormat}
                  />
                </ListItem>
                <ListItem
                  button
                  onClick={e => {
                    this.handleClick(2);
                  }}
                >
                  <ListItemIcon>{<TimerIcon />}</ListItemIcon>
                  <ListItemText
                    primary={languages.supportDrawer.createSchedule}
                  />
                </ListItem>
                <ListItem
                  button
                  onClick={e => {
                    this.handleClick(3);
                  }}
                >
                  <ListItemIcon>{<AirplayIcon />}</ListItemIcon>
                  <ListItemText primary={languages.supportDrawer.present} />
                </ListItem>
                <ListItem
                  button
                  onClick={e => {
                    this.handleClick(4);
                  }}
                >
                  <ListItemIcon>{<ViewListIcon />}</ListItemIcon>
                  <ListItemText
                    primary={languages.supportDrawer.processResults}
                  />
                </ListItem>
              </List>
            </div>

            <Divider />
            <List
              subheader={
                <ListSubheader>
                  {languages.supportDrawer.moreSupport}
                </ListSubheader>
              }
            >
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={languages.misc.faqURL}
                style={{ color: "#000", textDecoration: "none" }}
              >
                <ListItem button>
                  <ListItemIcon>{<HelpIcon />}</ListItemIcon>
                  <ListItemText primary={languages.header.faq} />
                </ListItem>
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://wa.me/31202117109"
                style={{ color: "#000", textDecoration: "none" }}
              >
                <ListItem button>
                  <ListItemIcon>{<ChatIcon />}</ListItemIcon>
                  <ListItemText
                    primary={languages.supportDrawer.startLiveChat}
                  />
                </ListItem>
              </a>
              <ListItem button onClick={this.props.handleFeaturesClick}>
                <ListItemIcon>{<SunnyIcon />}</ListItemIcon>
                <ListItemText primary={languages.header.featureRequest} />
              </ListItem>
            </List>
          </div>
        ) : (
          <div style={{ padding: 10 }}>
            <Button
              onClick={e => {
                this.handleClick(undefined);
              }}
              variant="text"
              size="small"
            >
              <ArrowBackIcon style={{ height: 18 }} />
              <span>{languages.general.back}</span>
            </Button>
            <br />
            <div style={{ padding: 5, marginTop: 5 }}>
              {supportTexts[this.state.supportText]}
            </div>
          </div>
        )}
      </Drawer>
    );
  }
}

SupportDrawer.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
};

export default withStyles(styles, { withTheme: true })(SupportDrawer);
